export default class ClinicMap {
    constructor() {
        async function initMap(m) {
            // Request needed libraries.
            const { Map } = await google.maps.importLibrary('maps');
            const { AdvancedMarkerElement } =
                await google.maps.importLibrary('marker');
            const markerImg = document.createElement('img');

            markerImg.src =
                '/wp-content/themes/bedrock-theme/static/images/marker-' +
                m.dataset.icon +
                '.svg';
            const map = new Map(m, {
                center: {
                    lat: parseFloat(m.dataset.lat),
                    lng: parseFloat(m.dataset.lng) - parseFloat(0.003),
                },
                zoom: 17,
                mapId: '4504f8b37365c3d0',
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                disableDefaultUI: true,
            });
            const marker = new AdvancedMarkerElement({
                map,
                position: {
                    lat: parseFloat(m.dataset.lat),
                    lng: parseFloat(m.dataset.lng),
                },
                content: markerImg,
                title: m.dataset.title,
            });
        }

        const m = document.querySelector('#map');
        if (m) {
            initMap(m);
        }
    }
}
